/* global require */
// this is a bit hacky
const ENV = process.env.REACT_APP_ENV;
export const config = require(`./${ENV.trim()}.config.js`);



// WEBPACK FOOTER //
// ./src/config/index.js